import "./sparkle_namespace.js";

window.Sparkle ??= {};
window.Sparkle.Events ??= {};

if (!window.Sparkle.Events) {
  window.Sparkle.Events = {};
}

window.Sparkle.Events.isKeyUpEnter = (e) => e && e.type === "keyup" && e.key === "Enter";

// Notify listeners that content has rendered
// Only triggers the event if the element is attached to the document since this is intended for use
// by unrelated code, e.g. 3rd-party scripts that want to know when Sparkle component content changes.
window.Sparkle.Events.contentUpdated = (el) => {
  if (!el.isConnected) {
    return;
  }
  const event = new CustomEvent("sparkle:content-did-update", { bubbles: true });
  return el.dispatchEvent(event);
};
